var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/SelectDependencies/ModelsTree/VersionButton/VersionButton.tsx";

/* eslint-disable react/forbid-component-props */
import React from 'react';
import clsx from 'clsx';
import { ErrorButton } from "./buttons/ErrorButton";
import { InProgressButton } from "./buttons/InProgressButton";
import { DoneButton } from "./buttons/DoneButton";
import { DownloadButton } from "./buttons/DownloadButton";
import { useBaseButtonStyles } from "./buttons/buttonStyles";
import { VersionInfoTooltip } from "./VersionInfoTooltip";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var VersionButton = /*#__PURE__*/React.memo(function (_ref) {
  var versionName = _ref.versionName,
      status = _ref.status,
      author = _ref.author,
      showVersion = _ref.showVersion,
      uploadDate = _ref.uploadDate,
      errorCode = _ref.errorCode;
  var classes = useBaseButtonStyles();
  var baseclassname = clsx(classes.root);
  var btnText = React.useMemo(function () {
    return showVersion ? /*#__PURE__*/_jsxs("span", {
      className: classes.text,
      children: ["v", versionName]
    }) : '';
  }, [classes.text, showVersion, versionName]);
  var buttonJSX = React.useMemo(function () {
    switch (status) {
      case 'NotImported':
        {
          return /*#__PURE__*/_jsx(DownloadButton, {
            className: baseclassname,
            children: btnText
          });
        }

      case 'ImportInProgress':
        {
          return /*#__PURE__*/_jsx(InProgressButton, {
            className: baseclassname,
            children: btnText
          });
        }

      case 'ImportCompleted':
        {
          return /*#__PURE__*/_jsx(DoneButton, {
            className: baseclassname,
            children: btnText
          });
        }

      case 'ImportError':
        return /*#__PURE__*/_jsx(ErrorButton, {
          className: baseclassname,
          children: btnText
        });
    }
  }, [baseclassname, btnText, status]);
  return /*#__PURE__*/_jsx(VersionInfoTooltip, {
    author: author,
    status: status,
    versionName: versionName,
    uploadDate: uploadDate,
    errorCode: errorCode,
    children: /*#__PURE__*/_jsx("span", {
      children: buttonJSX
    })
  });
});
VersionButton.displayName = 'VersionButton';